import { AskPlayers } from './AskPlayers'

export default AskPlayers